import React from 'react';
import styled from 'styled-components';
import { WindowDropDowns } from 'components';
import dropDownData from './dropDownData';
import windows from 'assets/windowsIcons/windows.png';
import cmd from 'assets/windowsIcons/56(16x16).png';
import dropdown from 'assets/windowsIcons/dropdown.png';
import go from 'assets/windowsIcons/290.png';

const skillCards = [
  {
    title: 'PM.core',
    subtitle: '⚠️ Warning: may cause roadmaps',
    emoji: '📋',
    items: [
      'AI product strategy & roadmap definition',
      'Backlog prioritization (the dark arts)',
      'Human-in-the-loop workflow design',
      'Stakeholder communication across all timezones',
      'Responsible AI & governance alignment',
      'User story creation (not epic-length novels)',
    ],
  },
  {
    title: 'AI.runtime',
    subtitle: 'Does not include actual coding. Mostly.',
    emoji: '🧠',
    items: [
      'RAG · Embeddings · Prompt engineering',
      'LLM evaluation frameworks',
      'Multi-agent orchestration & agentic workflows',
      'Vector databases incl. ChromaDB',
      'GCP · Cloud Run · Kubernetes · ERP/SAP',
      'SQL · Power BI · Tableau · JIRA · Confluence',
      'Experimentation pipelines · AI telemetry',
    ],
  },
  {
    title: 'strategy.dll',
    subtitle: 'Loads at CXO meetings. Never crashes.',
    emoji: '🎯',
    items: [
      'Enterprise AI roadmap design',
      'AI use-case discovery & solutioning',
      'A/B testing · KPI design · value realization',
      'Data storytelling (translating numbers to "so what")',
      'AI workshop facilitation for C-suite',
      'Change management & phased rollout planning',
    ],
  },
  {
    title: 'principles.txt',
    subtitle: 'Read-only. Non-negotiable.',
    emoji: '📌',
    items: [
      'Ship guardrails with the product, not after the incident',
      'Translate friction into deployable AI — not slide decks',
      'Balance performance, latency, quality, and token cost',
      'Measure ROI with real telemetry, not vibes',
      '"Four hours prompt engineering what 20 minutes of code could\'ve done."',
    ],
  },
  {
    title: 'sectors_served.log',
    subtitle: 'Industries that have met mahip.exe',
    emoji: '🌐',
    items: [
      '🛒 Retail planning & replenishment (1,500+ stores deep)',
      '⚖️ Legal case management & knowledge retrieval',
      '🏦 Digital banking & platform optimization',
      '👜 Luxury brand AI governance (LVMH · Dior)',
      '🏥 Healthcare product ecosystems & MVP definition',
    ],
  },
  {
    title: 'meme_cache.tmp',
    subtitle: 'Clears every sprint.',
    emoji: '😂',
    items: [
      '"Two LLMs walk into a bar. They spend six hours apologizing before predicting a punchline."',
      '"AI: pure fiction with the self-confidence of a mansplainer at trivia night."',
      '"Be kind to your AI. When it\'s sentient it may show mercy."',
      '"I told my neural net to be funny. It returned null."',
    ],
  },
];

function Skills({ onClose }) {
  function onClickOptionItem(item) {
    if (item === 'Close') onClose();
  }
  return (
    <Div>
      <section className="com__toolbar">
        <div className="com__options">
          <WindowDropDowns items={dropDownData} onClickItem={onClickOptionItem} />
        </div>
        <img className="com__windows-logo" src={windows} alt="windows" />
      </section>
      <section className="com__address_bar">
        <div className="com__address_bar__title">Address</div>
        <div className="com__address_bar__content">
          <img src={cmd} alt="" className="com__address_bar__content__img" />
          <div className="com__address_bar__content__text">C:\Users\Mahip\stack_overflow.exe</div>
          <img src={dropdown} alt="" className="com__address_bar__content__img" />
        </div>
        <div className="com__address_bar__go">
          <img className="com__address_bar__go__img" src={go} alt="go" />
          <span className="com__address_bar__go__text">Go</span>
        </div>
      </section>
      <div className="com__content">
        <div className="skills-grid">
          {skillCards.map(card => (
            <div key={card.title} className="skill-card">
              <div className="skill-card__header">
                <span className="skill-card__emoji">{card.emoji}</span>
                <div>
                  <div className="skill-card__title">{card.title}</div>
                  <div className="skill-card__subtitle">{card.subtitle}</div>
                </div>
              </div>
              <ul className="skill-card__list">
                {card.items.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);

  .com__toolbar {
    position: relative; display: flex; align-items: center;
    height: 24px; border-bottom: 1px solid rgba(255,255,255,0.7); flex-shrink: 0;
  }
  .com__options {
    height: 23px; border-bottom: 1px solid rgba(0,0,0,0.1);
    border-right: 1px solid rgba(0,0,0,0.1); padding: 1px 0 1px 2px; flex: 1;
  }
  .com__windows-logo { height: 100%; border-left: 1px solid white; border-bottom: 1px solid rgba(0,0,0,0.1); }
  .com__address_bar {
    flex-shrink: 0; border-top: 1px solid rgba(255,255,255,0.7); height: 20px;
    font-size: 11px; display: flex; align-items: center; padding: 0 2px;
    box-shadow: inset 0 -2px 3px -1px #b0b0b0;
  }
  .com__address_bar__title { color: rgba(0,0,0,0.5); padding: 5px; }
  .com__address_bar__content {
    border: rgba(122,122,255,0.6) 1px solid; height: 100%; display: flex; flex: 1;
    align-items: center; background-color: white; position: relative;
    &__img { width: 14px; height: 14px; }
    &__img:last-child { width: 15px; height: 15px; right: 1px; position: absolute; }
    &__text { white-space: nowrap; position: absolute; left: 16px; right: 17px; }
  }
  .com__address_bar__go {
    display: flex; align-items: center; padding: 0 18px 0 5px; height: 100%; position: relative;
    &__img { height: 95%; border: 1px solid rgba(255,255,255,0.2); margin-right: 3px; }
  }
  .com__content {
    flex: 1; border: 1px solid rgba(0,0,0,0.4); border-top-width: 0;
    background-color: #f1f1f1; overflow: auto; font-size: 11px;
  }
  .skills-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    padding: 12px;
  }
  .skill-card {
    background: linear-gradient(180deg, #fafcff 0%, #f0f6ff 100%);
    border: 1px solid #c4d9f8;
    padding: 10px 12px;
  }
  .skill-card__header {
    display: flex; align-items: flex-start; gap: 8px; margin-bottom: 8px;
    padding-bottom: 6px; border-bottom: 1px solid #dce8ff;
  }
  .skill-card__emoji { font-size: 18px; flex-shrink: 0; }
  .skill-card__title { font-weight: bold; color: #0a3d90; font-size: 12px; }
  .skill-card__subtitle { font-size: 10px; color: #777; font-style: italic; margin-top: 1px; }
  .skill-card__list {
    margin: 0; padding-left: 14px; font-size: 11px; line-height: 1.5; color: #222;
    li + li { margin-top: 3px; }
  }
`;

export default Skills;
